import { ApiBase } from '@/api/api'
import { makePostRequest } from '@/api/fetchCalls'

export type AddNewTagClientModel = {
  name: string
  color: string
}
export const addNewTagClient = async (
  data: AddNewTagClientModel
): Promise<void> => {
  return makePostRequest(ApiBase + `/customer_tags`, {
    body: JSON.stringify({ ...data }),
  })
}
